import { render, staticRenderFns } from "./editSecuritySetting.vue?vue&type=template&id=ae63d3b2&scoped=true&"
import script from "./editSecuritySetting.vue?vue&type=script&lang=js&"
export * from "./editSecuritySetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae63d3b2",
  null
  
)

export default component.exports